import * as React from 'preact/compat'
import SVG from './SVG'
import styles from '../../css/v9/components/rating-spinner.pcss.json'
import { loadStylesheet } from '../common/helpers'
import { RatingVote, type RatingVoteEventDetails } from '../common/apis'
import cn from 'classnames'

interface RatingSpinnerProps {
  targetType: string,
  targetId: number,
  value: number,
  isGuest: boolean,
  canVote: boolean,
  vote?: '+' | '-',
  link?: string,
  disableTabIndex?: boolean
  showDisabledButtons?: boolean,
  disableMinusButton?: boolean,
  outline?: boolean
}

interface RatingSpinnerState {
  vote: null | '+' | '-',
  value: number
}

export default class RatingSpinner extends React.Component<RatingSpinnerProps, RatingSpinnerState> {
  state = {
    vote: null,
    value: 0
  }

  constructor(props: RatingSpinnerProps) {
    super(props)
    if (this.props.vote) {
      this.state.vote = this.props.vote
    }
    this.state.value = this.props.value
  }

  getDerivedStateFromProps(newProps: RatingSpinnerProps) {
    return {
      ...this.state,
      vote: newProps.vote,
      value: newProps.value
    }
  }

  componentWillMount() {
    loadStylesheet('v9/components/rating-spinner')
  }

  rateSuccess = (event: CustomEvent<RatingVoteEventDetails>) => {
    const { targetType, targetId, result } = event.detail

    if (targetType === this.props.targetType
      && targetId === this.props.targetId
    ) {
      this.setState({
        vote: result.voteDirection,
        value: result.value
      })
    }
  }

  componentDidMount() {
    window.addEventListener('sg-rating-vote', this.rateSuccess)
  }

  componentWillUnmount() {
    window.removeEventListener('sg-rating-vote', this.rateSuccess)
  }

  vote = (value: '-' | '+') => {
    if (this.props.link) {
      window.location.href = this.props.link
      return
    }

    RatingVote(this.props.targetType, this.props.targetId, value)
  }

  voteMinus = (ev: React.TargetedEvent<HTMLButtonElement> & MouseEvent) => {
    ev.stopImmediatePropagation()
    ev.preventDefault()
    this.vote('-')
  }

  votePlus = (ev: React.TargetedEvent<HTMLButtonElement> & MouseEvent) => {
    ev.stopImmediatePropagation()
    ev.preventDefault()
    this.vote('+')
  }

  render() {
    const { isGuest, canVote, disableTabIndex, showDisabledButtons, disableMinusButton } = this.props
    const { vote, value } = this.state

    let ratingValue = `${value}`
    let tabindex = 0

    if (disableTabIndex) {
      tabindex = -1
    }

    if (value > 0) {
      ratingValue = `+${ratingValue}`
    }

    const minusClasses = cn({
      [styles['rating-spinner__button']]: true,
      [styles['rating-spinner__minus']]: true,
      [styles['active']]: vote === '-'
    })
    const plusClasses = cn({
      [styles['rating-spinner__button']]: true,
      [styles['rating-spinner__plus']]: true,
      [styles['active']]: vote === '+'
    })

    const ratingClasses = cn({
      [styles['rating-spinner__rating']]: true,
      [styles['rating-spinner__rating--positive']]: value > 0,
      [styles['rating-spinner__rating--negative']]: value < 0
    })

    return <div className={cn({
      [styles['rating-spinner']]: true,
      [styles['rating-spinner--outline']]: this.props.outline
    })}>
      {!disableMinusButton && (canVote || showDisabledButtons) && (isGuest
          ?
          <button className={minusClasses} data-plugins='auth' tabIndex={tabindex}><SVG i="sg-new/minus" adaptive/>
          </button>
          : <button className={minusClasses} onClick={this.voteMinus}
                    disabled={!canVote || vote === '-'} tabIndex={tabindex}><SVG i="sg-new/minus" adaptive/></button>)
      }
      <span className={ratingClasses}>{ratingValue}</span>
      {(canVote || showDisabledButtons) && (isGuest
          ?
          <button className={plusClasses} data-plugins='auth' tabIndex={tabindex}><SVG i="sg-new/plus" adaptive/>
          </button>
          : <button className={plusClasses} onClick={this.votePlus}
                    disabled={!canVote || (!disableMinusButton && vote === '+')} tabIndex={tabindex}><SVG i="sg-new/plus" adaptive/></button>
      )}
    </div>
  }
}
